import { styled } from '@grupoboticario/flora-react';

export default {
  Wrapper: styled('div', {
    background: '$light-light',
  }),

  CloseButtonContainer: styled('div', {
    display: 'flex',
    justifyContent: 'start',
    padding: '$2 $2 $0',

    button: {
      border: 'none',
    },
  }),

  Main: styled('main', {
    background: '$light-light',
    marginLeft: 'auto',
    marginRight: 'auto',
    maxWidth: 'calc(750px + 2*$5)',
    padding: '$0 $5 $3',

    hr: {
      border: 'none',
      borderBottomColor: '$medium-light-2',
      borderBottomStyle: 'solid',
      borderBottomWidth: '$hairline',
    },
  }),

  Title: styled('div', {
    margin: '$0',
    padding: '$7 $0 $0',
  }),

  OptionsSubtitle: styled('div', {
    padding: '$7 $0 $2',
    textTransform: 'uppercase',
  }),

  ButtonsContainer: styled('div', {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '$0 $0 $7',

    '&.active': {
      background: '$actionNavigationStandardStatic',
      color: '$actionNavigationAltStatic',
    },

    '@tablet': {
      justifyContent: 'start',
    },
  }),

  Button: styled('button', {
    background: 'transparent',
    borderColor: '$actionNavigationStandardStatic',
    borderRadius: '$small',
    borderStyle: 'solid',
    borderWidth: '$thin',
    color: '$actionNavigationStandardStatic',
    display: 'flex',
    flexWrap: 'wrap',
    padding: '$3 $1',
    justifyContent: 'center',
    textTransform: 'uppercase',
    width: 'calc(50% - $2)',

    svg: {
      height: '27px',
      width: 'auto',

      path: {
        fill: '$actionNavigationStandardStatic',
      },
    },

    span: {
      marginTop: '$2',
      width: '100%',
    },

    '@tablet': {
      marginRight: '$4',
      width: '132px',
    },

    variants: {
      active: {
        true: {
          background: '$actionNavigationStandardStatic',
          color: '$actionNavigationAltStatic',

          svg: {
            path: {
              fill: '$actionNavigationAltStatic',
            },
          },
        },
      },
    },
  }),

  Instructions: styled('div', {
    color: '$dark-dark',
    padding: '$7 $0 $0',

    h3: {
      marginBottom: ' $5',
    },

    ul: {
      listStyle: 'none',
      li: {
        marginBottom: '$2',
      },
    },
  }),

  GoToCatalogButton: styled('div', {
    display: 'flex',
    justifyContent: 'center',
    padding: '$8 $0',

    '@tablet': {
      justifyContent: 'start',
    },
  }),
};
